import { render, staticRenderFns } from "./learnAboutTheReserve.vue?vue&type=template&id=5a272e90"
import script from "./learnAboutTheReserve.vue?vue&type=script&lang=js"
export * from "./learnAboutTheReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports